var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer bg-light float fixed-bottom" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "row align-items-center", attrs: { id: "footer-2" } },
        [
          _c("div", { staticClass: "col" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("home.unlogged.rights-footer")))]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }